import { render, staticRenderFns } from "./JcCart.vue?vue&type=template&id=a5bc2638&scoped=true"
import script from "./JcCart.vue?vue&type=script&lang=js"
export * from "./JcCart.vue?vue&type=script&lang=js"
import style0 from "./JcCart.vue?vue&type=style&index=0&id=a5bc2638&prod&lang=css"
import style1 from "./JcCart.vue?vue&type=style&index=1&id=a5bc2638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bc2638",
  null
  
)

export default component.exports